// ClientSideErrorCodes.ORDER_SERVICE_BILLING_REJECTED in AwsBotsGrimsbyDataModels
export const ORDER_SERVICE_BILLING_REJECTED_CODE = 740;

interface UpdateResult {
    statusCode?: number;
    errorCode?: number | string;
    errorMessage?: string;
}

/**
 * True when OrderService rejected the billing update for a reason the user can
 * fix (e.g. inactive AWS account, no billing group). Both the status and the
 * response code are checked because other errors on the same endpoint also
 * return 422 (e.g. the DoNotShuffle error, response code 713).
 */
export const isOrderServiceBillingRejection = (result: UpdateResult) =>
    result.statusCode === 422 &&
    result.errorCode === ORDER_SERVICE_BILLING_REJECTED_CODE;

export const getOrderServiceRejectionText = (detail?: string) => {
    const reason = detail
        ? `: ${detail}${/[.!?]$/.test(detail) ? '' : '.'}`
        : '.';
    return `OrderService rejected the billing update for this activity${reason} Please correct the billing details and try again.`;
};
